export default function(map) {
  var entries = [];
  for (var key in map) entries.push({key: key, value: map[key]});
  return entries;
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-collection/src/entries.js
// module id = kczg
// module chunks = 0